import * as React from "react";
import {IJobComponentPropsData, IJobComponentPropsFunctions} from "../props/IJobComponentProps";
import Box from '../../../parts/Box';
import FinishedJobContainer from "../containers/FinishedJobContainer";
import {jobStatusNames} from "../../../settings";
import IJobInfo from "../interfaces/IJobInfo";
import JobContext from "../JobContext";
import InputFileButtonsContainer from "../containers/InputFileButtonsContainer";
import {Helmet} from "react-helmet";
import { Col, Row } from 'reactstrap';
import ChainTable from './TableChains';
import { ChainTableDetails } from "../../../TableColumns";

type IProps = IJobComponentPropsData & IJobComponentPropsFunctions & {match: {params: {jobId: string}}};

export default class JobComponent extends React.Component<IProps> {

    timeout: any = null;

    getJobId(props: IProps | null = null): string {
        if (props === null) {
            props = this.props;
        }
        return props.match.params.jobId;
    }

    componentDidMount() {
        this.props.loadJobInfo(this.getJobId(), true, this.handleInfoReceived);
    }

    componentDidUpdate(prevProps: IProps) {
        if (this.getJobId(prevProps) !== this.getJobId()) {
            // job id changed
            if (this.timeout !== null) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.props.loadJobInfo(this.getJobId(), true, this.handleInfoReceived);
        }
    }

    componentWillUnmount() {
        if (this.timeout !== null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }

    getChainData = () => {
        var data = [];
        if(this.props.chainMapping !== null){
            Object.keys(this.props.chainMapping).map((chain) => (
                data.push({
                    id: chain,
                    orig: this.props.chainMapping[chain]
                })
            )) 
        }
        return data;
    }

    handleInfoReceived = (info: IJobInfo) => {
        if (info.status !== 5 && info.status !== -1) {
            this.timeout = setTimeout(() => {
                this.props.loadJobInfo(this.getJobId(), false, this.handleInfoReceived);
            }, 60000);
        }
    }

    renderData = () => {
        const jobInfo = this.props.jobState.jobInfo;
        if (jobInfo === null) {
            return null;
        }
        return <>
            <tr>
                <th>Title:</th>
                <td>{jobInfo.title}</td>
            </tr>
            {this.props.pdbId !== null && this.props.pdbId !== "" && (
                <tr>
                    <th>Structure:</th>
                    <td>{this.props.pdbId}</td>
                </tr>
            )}
            <tr>
                <th>Time:</th>
                <td>{jobInfo.time}</td>
            </tr>
            <tr>
                <th>Status:</th>
                <td>{jobInfo.inQueue ? "In queue" : jobStatusNames[jobInfo.status]}</td>
            </tr>
        </>
    }

    render() {

        const jobId = this.getJobId();
        return <div>
            <Helmet>
                <title>{`Job ${jobId}`}</title>
            </Helmet>

            <JobContext.Provider value={jobId}>
                <div>
                <div className="ll-box-group">
                    <Box title="Job output information">
                        <Row>
                        <Col>
                        <table className="ll-info-table">
                            <thead>
                                <tr>
                                    <th>ID:</th>
                                    <td>{this.getJobId()}</td>
                                </tr>
                                {this.renderData()}
                            </thead>
                        </table>
                        {/*this.props.jobState.jobInfo === null && this.props.jobState.fetching && <p>Fetching...</p>*/}
                        {/*this.props.jobState.fetchNotFound && <p>Requested job not found.</p>*/}
                        {/*this.props.jobState.fetchFailed && <p>Fetch failed. Please reload the page.</p>*/}
                        {/*this.props.jobState.jobInfo !== null && this.props.jobState.jobInfo.status === 5 && <p>Job is finished.</p>*/}
                        </Col>
                        {this.props.jobState.jobInfo !== null && this.props.jobState.jobInfo.status === 5 && (
                            <Col>
                            <strong>Multimer chain mapping:</strong>
                            <ChainTable 
                                data={this.getChainData()}
                                columns={ChainTableDetails} 
                            />
                            </Col>
                        )}
                        
                        </Row>
                    </Box>
                </div>
                {this.props.jobState.jobInfo !== null && this.props.jobState.jobInfo.status === 5 && (
                        <FinishedJobContainer jobId={jobId} />
                    )}
                </div>
            </JobContext.Provider>
        </div>
    }

}
